// extracted by mini-css-extract-plugin
export default {"balance":"Balance_balance__41oSS","balance_text":"Balance_balance_text__qK2Pp","balance_amount":"Balance_balance_amount__pt8LA"};